import { toast } from "react-toastify";

import {
  UploadCogsDataRequestBodyType,
  UploadCogsDataResponse,
} from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";

const uploadCogsData = async (data: UploadCogsDataRequestBodyType) => {
  const resp = await api.post<UploadCogsDataResponse>(
    `/v2/organizations/upload-cogs-data`,
    {
      ...data,
    }
  );
  return resp.data;
};

export const useUploadCogsData = () => {
  return useMutation({
    mutationFn: async (data: UploadCogsDataRequestBodyType) =>
      uploadCogsData(data),
    onSuccess: (data) => {
      if (data.changed === 0) {
        toast.success(`No change detected in COGS data`);
      } else {
        toast.success(`COGS data has been uploaded (${data.changed} changed).`);
      }
    },
  });
};
